/* eslint-disable import/prefer-default-export */
import React from "react";

/** Fabricate change events to allow interopability with Formik */
export const createChangeEvent = (name, value) => ({
  target: { name, value },
} as React.ChangeEvent<any>);
